import { lazy } from "react";

const AuthWrapper = lazy(() => import("../containers/AuthWrapper"));
const Ledger = lazy(() => import("../containers/Main/Ledgers"));
const Dashboard = lazy(() => import("../containers/Main/Dashboard"));
const RiskManagement = lazy(() => import("../containers/Main/RiskManagement"));
const Analytics = lazy(() => import("../containers/Main/Analytics"));
const Leaderboard = lazy(() => import("../containers/Main/Leaderboard"));
const WatchList = lazy(() => import("../containers/Main/WatchList"));
const Kanban = lazy(() => import("../containers/Main/Kanban/index.js"));
const AutoExit = lazy(() => import("../containers/Main/AutoExit"));
const Options = lazy(() => import("../containers/Main/OptionsWorker"));
const OptionsResearch = lazy(() => import("../containers/Main/OptionsResearch"));
const PivotTest = lazy(() => import("../containers/Main/PivotTest"));
const LandingPage = lazy(() => import("../components/landing_Page"));
const Services = lazy(() => import("../pages/Services"));
const Feedback = lazy(() => import("../containers/Main/Feedback"));
const Mentorship = lazy(() => import("../containers/Main/Mentorship"));
const StockScreener = lazy(() => import("../containers/Main/StockScreener"));
const VcpLiveScanner = lazy(() => import("../containers/Main/VcpLiveScanner"));
const Patternz = lazy(() => import("../containers/Main/Patternz"));
const LiveMis = lazy(() => import("../containers/Main/LiveMis"));
const PatternzChart = lazy(() => import("../containers/Main/PatternzChart"));
const SharedMentorTrade = lazy(() => import("../pages/SharedMentorTrade"));
const PublicInformation = lazy(() => import("../pages/PublicInformation"));

export const appRoutes = [
  {
    key: "main",
    path: "/",
    component: AuthWrapper,
    nestedRoutes: [
      {
        key: "home",
        path: "/",
        component: Ledger,
      },
      {
        key: "riskManagement",
        path: "/risk-management",
        component: RiskManagement,
      },
      {
        key: "dashboard",
        path: "/dashboard",
        component: Dashboard,
      },
      {
        key: "autoExit",
        path: "/auto-exit",
        component: AutoExit,
        tradeToolOnly: true,
      },
      {
        key: "options",
        path: "/options",
        component: Options,
        tradeDeskOnly: true,
      },
      {
        key: "optionsResearch",
        path: "/options-research",
        component: OptionsResearch,
        tradeToolOnly: true,
      },
      {
        key: "liveMis",
        path: "/live-mis",
        component: LiveMis,
        tradeToolOnly: true,
      },
      {
        key: "pivotTest",
        path: "/pivot-test",
        component: PivotTest,
        tradeToolOnly: true,
      },
      {
        key: "watchlist",
        path: "/watch-list",
        component: WatchList,
      },
      {
        key: "analytics",
        path: "/analytics",
        component: Analytics,
      },
      {
        key: "leaderboard",
        path: "/leaderboard",
        component: Leaderboard,
      },
      {
        key: "Kanban",
        path: "/watchlist",
        component: Kanban,
      },
      {
        key: "feedback",
        path: "/feedback",
        component: Feedback,
      },
      {
        key: "circles",
        path: "/circles",
        component: Mentorship,
      },
      {
        key: "mentorshipLegacy",
        path: "/mentorship",
        component: Mentorship,
      },
      {
        key: "stockScreener",
        path: "/screener",
        component: StockScreener,
      },
      {
        key: "vcpLiveScanner",
        path: "/vcp-scanner",
        component: VcpLiveScanner,
      },
      {
        key: "patternz",
        path: "/patternz",
        component: Patternz,
      },
      {
        key: "patternzChart",
        path: "/patternz/:patternType/:symbol",
        component: PatternzChart,
      },
    ],
  },
  {
    key: "home",
    path: "/home",
    component: LandingPage,
  },
  {
    key: "services",
    path: "/services",
    component: Services,
  },
  { key: "privacy", path: "/privacy", component: PublicInformation },
  { key: "terms", path: "/terms", component: PublicInformation },
  { key: "contact", path: "/contact", component: PublicInformation },
  {
    key: "sharedMentorTrade",
    path: "/trade/:shareToken",
    component: SharedMentorTrade,
  },
];
